import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';

import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from "reactstrap";


const PartyCategoryMaster = () => {

    const navigate = useNavigate();
    const [partyCategoryTable, setPartyCategoryTable] = useState([]);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination


    const onHandleSearchKeyItem = (e) => {
        const value = e.target.value; // Assuming you're trying to get the value from an input field
        getPartyCategoryData(1, 10, value)
    }

    const onHandleAddPartyCategory = () => {
        navigate("/addpartyCategory")
    }

    const onHandleEditPartyCategory = (id) => {
        let findArrayData = partyCategoryTable.find(e => e.id === id)
        navigate('/addpartyCategory', { state: { id: findArrayData?.id, party_category_name: findArrayData?.party_category_name } });
    }

    const getPartyCategoryData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/PartyCategoryMaster/allpartycategory?pageNo=1&limit=10&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);

            }

            if (response.status === true) {
                console.log(response.categoryMasterDetailData)
                setPartyCategoryTable(response.partyCategoryMasterData)
                setTotalPage(response.totalPages)
                // toast.success(response.message);
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
             toast.error(`SomeThing went wrong!!`);
        }
    };

    useEffect(() => {
        getPartyCategoryData();
    }, [!partyCategoryTable]);

    const handlePageClick = (data) => {
        getPartyCategoryData(data.selected + 1)
    };

    const onHandleDeletePartyCategory = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`api/PartyCategoryMaster/delete?partyCategoryId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.error(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getPartyCategoryData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                 toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };





    return (
        <>
            <Col lg="12">
                <Card className='card-box height-100-p pd-20 mb-20'>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-card-text mr-2"></i>
                            Party Category Master
                        </div>

                        <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
                            <Input  className="custom-border" id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
                        </Row>

                        <Button color="primary" size="bg" onClick={onHandleAddPartyCategory}>Add</Button>
                    </CardTitle>

                    <CardBody className="">
                        <div className="table-responsive">
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>id</th>
                                        <th>Party Category Name</th>
                                        <th>Under Account( Balance Sheet Account)</th>
                                        <th>Type</th>
                                        <th>If Sub Then Main Account Name</th>
                                        <th>Edit</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {partyCategoryTable?.map((item, index) => (
                                        <tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{item.category_name}</td>
                                            <td>{item.balance_sheet_cate_name}</td>
                                            <td>{item.cate_type}</td>
                                            <td>{item.cate_name_if_sub_Selected}</td>


                                            <td>
                                                <Button color="success" size="bg" onClick={() => onHandleEditPartyCategory(item.id)}>
                                                    <i className="bi bi-pencil text-primary"></i>
                                                </Button>
                                            </td>
                                            {/* <td>
                                            <Button color="danger" size="bg" onClick={() => onHandleDeletePartyCategory(item.id)}>
                                                Delete
                                            </Button>
                                        </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>


                </Card>
            </Col>
        </>
    )
}

export default PartyCategoryMaster